export const STORAGE_KEY = "host-news-read-articles-v1";
